import React from 'react';
import { browserInfo } from './browser_info';
import { map } from 'lodash';

interface IProps {
  inputPrefix?: string;
}

export default class BrowserInfoHiddenFields extends React.Component<IProps, null> {
  static defaultProps: IProps = {
    inputPrefix: 'browser_info',
  };

  renderBrowserInfo() {
    return map(browserInfo(), (value, key) => {
      return (
        <input
          type="hidden"
          name={`${this.props.inputPrefix}[${key}]`}
          key={`${this.props.inputPrefix}-${key}`}
          value={value as string}
        />
      );
    });
  }

  render() {
    return (
      <div>
        {this.renderBrowserInfo()}
      </div>
    );
  }
}
